import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const KeyValueLoader: React.FC<{
  className?: string;
  isMobile?: boolean;
  customHeight?: number;
}> = ({ className, isMobile, customHeight }) => {
  if (isMobile) {
    return (
      <ContentLoader width={280} height={24} className={className}>
        <rect width="60" height="16" x="0" y="4" />
        <rect width="90" height="24" x="190" y="0" />
      </ContentLoader>
    );
  }

  return (
    <ContentLoader width={80} height={customHeight || 60} className={className}>
      <rect width="60" height="10" x="0" y="0" />
      <rect width="80" height="30" x="0" y="15" />
    </ContentLoader>
  );
};

export default KeyValueLoader;
